<html>
<head>

    <meta name="viewport" content="width=device-width, initial-scale=1"> <!-- Ensures optimal rendering on mobile devices. -->
    <meta http-equiv="X-UA-Compatible" content="IE=edge" /> <!-- Optimal Internet Explorer compatibility -->
  <script src="https://www.paypal.com/sdk/js?client-id=AatuzW_dm2K7y5P4WRE5ZT6xnDZW7ZfwS551X9bCWPENuQTs5Zi4h3AMKPVAlINGW9_80Z58Emx9aUMe"></script>
  <script>

      paypal.Buttons().render('#paypal-button-container');
      // This function displays Smart Payment Buttons on your web page.
    </script>
  <link href="https://fonts.googleapis.com/css2?family=Turret+Road:wght@700&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Syne+Mono&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@100;400&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">
</head>

<body>
      <app-caroseul></app-caroseul>
<mat-card style="background-color: #112c41; margin: 0px;">
<mat-tab-group mat-align-tabs="center"  animationDuration="1000ms" style="font-weight: bold; margin: 0;">
  <mat-tab style="font-weight: bold; background-color: #112c41 ; color:#E0FFFF; font-size:50px;" label="Home" ><app-mission></app-mission><app-skill></app-skill></mat-tab>
  <!--<mat-tab  style="font-weight: bold;color:#E0FFFF;" label="Location"><app-location></app-location> </mat-tab>-->
  <mat-tab  style="font-weight: bold;color:#E0FFFF; font-size:50px;" label="Servizi" >
    <app-servizi></app-servizi>
  </mat-tab>
  <mat-tab  style="font-weight: bold;color:#E0FFFF; font-size:50px;" label="Login"><router-outlet></router-outlet></mat-tab>
</mat-tab-group>
</mat-card>
      <p></p>

        <div class="row">
          <div class="col-1"></div>
          <div class="col-10"><p style="margin-top: 3%; font-weight: bold; color: #E0FFFF; ">
            PER SUPPORTO COSTANTE, CONSULENZE, CONSIGLI E PRENOTAZIONI DI LEZIONI INDIVIDUALI,
            PRESSO LE SEDI IN CUI SVOLGO LA MIA PROFESSIONE, NON ESITARE A CONTATTARMI.</p>
            <p  style="font-weight: bold; color: #E0FFFF;">TI ASPETTO!</p></div>
          <div class="col-1"></div>
        </div>
  <app-recensione></app-recensione>
  <app-footer></app-footer>
  <app-putrecensione></app-putrecensione>
  <div class="marquee"><p>2020 © Designed by
    <a href="https://www.dandreafrancesco.it">Dandrea Francesco</a> | Torino</p></div>
</body>
</html>
